<template>
    <BuilderBase>
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1 clickable" @click="popupBuilderWelcome">
                    <span class="steps">{{$t('common.step_1')}} 1<span class="slash">/</span>3:</span> <span class="title">{{$t('views.dataset_builder.title_short')}}</span>
                    <div class="icon-information-neg"></div>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <BuilderOptions />
        </template>
    </BuilderBase>
</template>

<script>
    import { mapState } from 'pinia';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import BuilderBase from '@/views/builder/BuilderBase';
    import BuilderOptions from '@/components/builder/builder/BuilderOptions';
    import { popupBuilderWelcome } from '@/utils/popups';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            BuilderBase,
            BuilderOptions
        },
        data() {
            return {
                seo_title: 'views.dataset_builder.seo_title'
            };
        },
        computed: {
            ...mapState(useDatasetStore, ['loading']),
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            popupBuilderWelcome
        },
        mounted() {
            if(!this.datasetStore.query) {
                this.datasetStore.fetchDataset();
            }
        }
    }
</script>